import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function K() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const [isEnter, setIsEnter] = useState(false);

    useEffect(() => {
        AniContainer.create({
            triggerElement: '.d2x-detail-K .text-box3',
            triggerHook: 1,
            offset: '40%',
            duration: '10%',
            onEnter: () => {
                setIsEnter(true);
            },
            isGpu: false,
        });
    }, []);

    return (
        <div
            className={`d2x-detail-K ${css.d2xDetailK} GtmModuleData-section`}
            id="d2x-detail-K"
            data-section-id={'d2x-detail-K'}
            data-section-title={t('sec11_title')}
        >
            <div className="text-box text-box1">
                <div className="left">
                    <div className="desc">{t('sec11_desc')}</div>
                    <div className="title">{t('sec11_title')}</div>
                </div>
                <div className="right">
                    <div className="desc2">{t('sec11_desc2')}</div>
                </div>
            </div>
            <div className="img-box">
                <NextImage webpSrc={require('@publicLocal/delta2max/detail/pc/10.webp')} src={require('@publicLocal/delta2max/detail/pc/10.jpg')} />
            </div>
            <div className="text-box text-box2">
                <div className="left">
                    <div className="slogan">
                        {t.rich('sec11_slogan', {
                            title: (text: any) => <div className="strong">{text}</div>,
                        })}
                    </div>
                </div>
                <div className="right">{t('sec11_desc3')}</div>
            </div>
            <div className="text-box text-box3">
                <div className="header">
                    <div className="slogan">{t('sec11_header_desc1')}</div>
                    <div className="slogan">{t('sec11_header_desc2')}</div>
                </div>
                <div className="content">
                    <div className="left">
                        <div className="charge-times">
                            <div>
                                {t.rich('sec11_charge_time1', {
                                    line: (text: any) => <span>{text}</span>,
                                })}
                            </div>
                            <div>
                                {t.rich('sec11_charge_time2', {
                                    line: (text: any) => <span>{text}</span>,
                                })}
                            </div>
                            <div>
                                {t.rich('sec11_charge_time3', {
                                    line: (text: any) => <span>{text}</span>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={`right ${isEnter ? 'isEnter' : ''}`}>
                        <div className="process-boxs">
                            <div className="process-box">
                                <div className="bar-box">
                                    <div className="bar bar1">
                                        <div className="process"></div>
                                    </div>
                                    <div className="text">{t('sec11_process1')}</div>
                                </div>
                                <div className="value-box">
                                    <div className="value">{t('sec11_process1_value')}</div>
                                    <div className="unit">{t('sec11_unit')}</div>
                                </div>
                            </div>
                            <div className="process-box">
                                <div className="bar-box">
                                    <div className="bar bar2">
                                        <div className="process"></div>
                                    </div>
                                    <div className="text">{t('sec11_process2')}</div>
                                </div>
                                <div className="value-box">
                                    <div className="value">{t('sec11_process2_value')}</div>
                                    <div className="unit">{t('sec11_unit')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
